import { useCallback, useEffect } from 'react';
import { queryFeatures } from '../services/esri';
import { CONFIG_URLS } from '../config/url.config';
import utilsController from '../controllers/UtilsController';
import { useDispatch } from 'react-redux';
import { setSpeciesData } from '../store/slices/appSlice';

const params = {
  where: '1=1',
  outFields: ['*'],
  returnGeometry: false,
  returnDistinctValues: true,
};
const useGetSpeciesData = () => {
  const dispatch = useDispatch();
  const getData = useCallback(async () => {
    const response = await queryFeatures(params, CONFIG_URLS.REFERENCE_PLATFORM);
    if (response.success) {
      const attributes = utilsController.getAttributes(response.data);
      const species = attributes.map((attribute) => {
        return {
          label: attribute.Genus,
          value: attribute.SampleTableLink,
          reportText1: attribute.ReportText1,
          commonName: attribute.CommonName,
        };
      });
      dispatch(setSpeciesData(species));
    }
  }, [dispatch]);

  useEffect(() => {
    getData();
  }, [getData]);

  return null;
};

export default useGetSpeciesData;
